module.exports = __webpack_public_path__ + "img/logo-icon.640b7e50.png";